module.exports = __webpack_public_path__ + "img/folder4.f58fb4d9.png";